import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import ActionComponent from '../../../components/ActionComponent'
import { getSandreList, removeNullKeys } from '../../../utils/StoreUtils'
import StationMapDashboardPanel from '../../../station/components/dashboard/component/map/StationMapDashboardPanel'
import Input from '../../../components/forms/Input'
import DatePicker from '../../../components/forms/DatePicker'
import NumberField from '../../../components/forms/NumberField'
import Select from '../../../components/forms/Select'
import Textarea from '../../../components/forms/Textarea'
import Checkbox from '../../../components/forms/Checkbox'
import { SANDRE } from '../../../referencial/constants/ReferencialConstants'
import { hasValue } from '../../../utils/NumberUtil'
import LastEventPanel from '../../../station/components/event/LastEventPanel'
import ContactCard from '../../../referencial/components/contact/components/ContactCard'
import StationUpdatePanel from '../../../station/components/update/StationUpdatePanel'
import { some } from 'lodash'
import { getControlColor } from '../../../utils/InstallationUtils'
import { getColorCircleElement, getRGBColor } from '../../../utils/ColorUtil'
import DtoInstallation from '../../dto/installation/DtoInstallation'
import CityDto from '../../../referencial/components/city/dto/CityDto'
import DtoSandreCode from '../../../referencial/dto/DtoSandreCode'
import ContributorDto from '../../../referencial/components/contributor/dto/ContributorDto'
import UserDto from '../../../administration/components/user/dto/UserDto'
import DtoStatus from '../../../quality/dto/DtoStatus'
import DtoInstallationEvent from '../../dto/installation/DtoInstallationEvent'
import InstallationAction from '../../actions/InstallationAction'
import DtoPollutedSoil from './dto/DtoPollutedSoil'
import DtoInstallationActivity from '../../dto/industrialSite/DtoInstallationActivity'
import LinkedStationsPanel from '../../../station/components/associatedStation/LinkedStationsPanel'
import MaterielAssigned from '../../../station/components/materiel/MaterielAssigned'

import InstallationInfosDashboard from '../installations/components/InstallationInfosDashboard'
import UnitChartPanel from '../../../productionUnit/components/UnitChartPanel'
import { H_MAT_MODULE } from '../../../account/constants/AccessRulesConstants'
import HabilitationRequired from '../../../utils/components/HabilitationRequired'
import InstallationCounterPanel from '../installationDefault/InstallationCounterPanel'
import { Card, CardContent, Grid2 } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'

class PollutedSoilDashboardPanel extends ActionComponent {
    state = {
        uncheckedStations: [],
    }
    componentDidMount() {
        this.props.fetchPollutedSoil(this.props.installation.id)
        this.props.fetchActivities()
    }

    getOriginIcon = (installation) => {
        return hasValue(installation.jobExecutionId) ? (
            <h6 className='valign-wrapper'>
                <i className='material-icons rem-3-size padding-right-1'>wifi</i>
                {i18n.automaticUpdate}
            </h6>
        ) : null
    }

    getOriginStatusColor = (installation) => {
        if (hasValue(installation.status)) {
            const color = getControlColor(installation.status)
            return getColorCircleElement(getRGBColor(color), true)
        }
        return null
    }

    render() {
        const installation = this.props.installation
        const pollutedSoil = this.props.pollutedSoil
        const readMode = { readMode: true, editMode: false, hideNull: true }

        return (
            <Grid2 container sx={{ padding: '10px 0 60px 0' }} spacing={1} alignItems={'flex-start'}>
                <Grid2 container size={9}>
                    <Grid2 size={12}>
                        <InstallationInfosDashboard />
                    </Grid2>
                    {some(['exploitationCode', 'comments'], key => hasValue(installation[key])) && (
                        <Grid2 size={12}>
                            <Card>
                                <CardTitle title={i18n.characteristics} />
                                <CardContent>
                                    <Grid2 container sx={{ paddingTop: 1 }}>
                                        <Grid2 size={6}>
                                            <Checkbox checked={hasValue(installation.exploitationCode) ? installation.exploitationCode == 1 : null}
                                                label={i18n.exploitation} disabled {...readMode}
                                            />
                                        </Grid2>
                                        <Grid2 size={6}>
                                            <Textarea value={installation.comments} title={i18n.comment} {...readMode} />
                                        </Grid2>
                                    </Grid2>
                                </CardContent>
                            </Card>
                        </Grid2>
                    )}
                    <Grid2 size={12}>
                        <InstallationCounterPanel
                            stationId={installation.id}
                            showTitle
                            showKeyFigures
                            inPopup
                        />
                    </Grid2>
                    <UnitChartPanel unit={this.props.installation} uncheckedStations={this.state.uncheckedStations} setDataLoaded={this.props.setDataLoaded} fromStationType='INST' />
                    {!hasValue(Object.keys(removeNullKeys({ ...pollutedSoil, id: null })).length) && (
                        <Grid2 size={12}>
                            <Card>
                                <CardTitle title={i18n.pollutedSoil}/>
                                <CardContent>
                                    <Grid2>
                                        <Grid2 size={6}>
                                            <Input value={pollutedSoil.icpeCode} title={i18n.icpeCode} {...readMode} />
                                        </Grid2>
                                        <Grid2 size={6}>
                                            <Select label={i18n.activityCode} options={this.props.activities} value={pollutedSoil.activityCode} displayWithCode {...readMode} />
                                        </Grid2>
                                    </Grid2>
                                </CardContent>
                            </Card>
                        </Grid2>
                    )}
                </Grid2>
                <Grid2 container size={3}>
                    <Grid2 container marginRight={1}>
                        <Grid2 size={12}>
                            <StationUpdatePanel station={installation} />
                        </Grid2>
                        {some(['dataOrigin', 'closeComment', 'status', 'statusDate', 'deliberationDate', 'confidential'], key => hasValue(installation[key])) && (
                            <Grid2 size={12}>
                                <Card>
                                    <CardContent>
                                        {this.getOriginIcon(installation)}
                                        <Grid2 size={12} sx={{ paddingTop: 1 }}>
                                            <Input title={i18n.dataOrigin} value={installation.dataOrigin} {...readMode} />
                                        </Grid2>
                                        <Grid2 size={12}>
                                            <Select label={[this.getOriginStatusColor(installation), i18n.status]} value={installation.status} options={this.props.status} {...readMode}/>
                                        </Grid2>
                                        <Grid2 size={12}>
                                            <DatePicker value={installation.statusDate} id='statusDate' title={i18n.controlDoneAt} {...readMode} />
                                        </Grid2>
                                        <Grid2 size={12}>
                                            <Select label={i18n.controlDoneBy} value={installation.statusLogin}
                                                options={this.props.users.map(u => ({ code: u.login, name: u.name || u.login }))} {...readMode}
                                            />
                                        </Grid2>
                                        <Grid2 size={12}>
                                            <DatePicker value={installation.endDate} id='deliberationDate' title={i18n.deliberationDate} {...readMode} />
                                        </Grid2>
                                        <Grid2 size={12}>
                                            <Input value={installation.closeComment} title={i18n.become} {...readMode} />
                                        </Grid2>
                                        <Grid2 size={12}>
                                            <Checkbox label={i18n.confidential} {...readMode}
                                                checked={hasValue(installation.confidential) ? installation.confidential == '1' : null} disabled
                                            />
                                        </Grid2>
                                    </CardContent>
                                </Card>
                            </Grid2>
                        )}
                        <ContactCard
                            title={i18n.contact}
                            contactCode={installation.ownerCode}
                            {...readMode}
                        />
                        {some(['address', 'x', 'y', 'altitude', 'parcel', 'section', 'ignMap', 'geologicalMap'], key => hasValue(installation[key])) && (
                            <Grid2 size={12}>
                                <Card>
                                    <CardContent>
                                        <Grid2 size={12}>
                                            <Input title={i18n.address} value={installation.address} {...readMode} />
                                        </Grid2>
                                        <Grid2 size={12}>
                                            <Select value={installation.townCode} label={i18n.city} options={this.props.cities} keyValue='id' displayWithCode {...readMode} />
                                        </Grid2>
                                        <Grid2 container size={12} spacing={1}>
                                            <Grid2 size={6}>
                                                <NumberField title='X' value={installation.x} floatValue {...readMode} />
                                            </Grid2>
                                            <Grid2 size={6}>
                                                <NumberField title='Y' value={installation.y} floatValue {...readMode} />
                                            </Grid2>
                                        </Grid2>
                                        <Grid2 container size={12} spacing={1}>
                                            <Grid2 size={6}>
                                                <NumberField title='Z' value={installation.altitude} floatValue {...readMode} />
                                            </Grid2>
                                            <Grid2 size={6}>
                                                <Select label={i18n.projection} value={installation.projection}
                                                    options={getSandreList(this.props.sandreCodes, SANDRE.PROJECTION)} {...readMode}
                                                />
                                            </Grid2>
                                        </Grid2>
                                    </CardContent>
                                </Card>
                            </Grid2>
                        )}
                        <HabilitationRequired habilitation={H_MAT_MODULE}>
                            <MaterielAssigned stationId={this.props.installation.id} type={this.props.stationType} />
                        </HabilitationRequired>
                        <Grid2 size={12}>
                            <LastEventPanel id={this.props.installation.id} events={this.props.installationEvents} stationId={this.props.installation.id}
                                stationType='installation'
                            />
                        </Grid2>
                        <Grid2 size={12}>
                            <StationMapDashboardPanel noMarkerTooltip station={installation} type={'installation'} />
                        </Grid2>
                        <Grid2 size={12}>
                            <LinkedStationsPanel
                                onReMount={ this.props.onReMount }
                                dashboardMode
                                checkable
                                changeUncheckedStations={ tab => this.setState({ uncheckedStations: tab })}
                                station={ this.props.installation } withColors
                            />
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>
        )
    }
}

PollutedSoilDashboardPanel.propTypes = {
    setDataLoaded: PropTypes.func,
    onRemount: PropTypes.func,
    stationType: PropTypes.string,
    installation: PropTypes.instanceOf(DtoInstallation),
    cities: PropTypes.arrayOf(PropTypes.instanceOf(CityDto)),
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    users: PropTypes.arrayOf(PropTypes.instanceOf(UserDto)),
    status: PropTypes.arrayOf(PropTypes.instanceOf(DtoStatus)),
    installationEvents: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallationEvent)),
    pollutedSoil: PropTypes.instanceOf(DtoPollutedSoil),
    activities: PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallationActivity)),
}

const mapStateToProps = store => ({
    installation: store.InstallationReducer.installation,
    cities: store.CityReducer.cities,
    sandreCodes: store.ReferencialReducer.sandreCodes,
    contributors: store.ContributorReducer.contributors,
    users: store.UserReducer.users,
    status: store.QualityReducer.status,
    installationEvents: store.InstallationReducer.installationEvents,
    pollutedSoil: store.InstallationReducer.pollutedSoil,
    activities: store.InstallationReducer.activities,
})

const mapDispatchToProps = {
    fetchActivities: InstallationAction.fetchActivities,
    fetchPollutedSoil: InstallationAction.fetchPollutedSoil,
}

export default connect(mapStateToProps, mapDispatchToProps)(PollutedSoilDashboardPanel)